import { CargoDropDown } from "../../../../../../common/domain/models/cargo_dropdown";
import { FuncionarioDropDown } from "../../../../../../common/domain/models/funcionario_dropdown";
import { CentroCustoDropDown } from "../../../../../../common/domain/models/centro_custo_dropdown";
import { DefaultAutocomplete } from "../../../../../../common/components/default_autocomplete";
import { DefaultMultiAutocomplete } from "../../../../../../common/components/default_multi_autocomplete";
import { DefaultDateRangePickerInput } from "../../../../../../common/components/default_date_range_picker_input";

import CascateList from "../../../../../../common/components/cascate_list";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import PrimaryButton from "../../../../../../common/components/primary_button";

/**
 * Header
 */

type Props = {
  selectedIdCargo: number | null,
  cargos: CargoDropDown[],
  selectedIdFuncionario: number | null,
  funcionarios: FuncionarioDropDown[],
  selectedIdCentroCustos: number[] | null,
  centroCustos: CentroCustoDropDown[],
  vencimentoDe: Date | null,
  vencimentoAte: Date | null,
  onSelectedCargoChange: (cargo: number | null) => void,
  onSelectedFuncionarioChange: (funcionario: number | null) => void,
  onSelectedCentroCustoChange: (centroCusto: number[] | null) => void,
  onVencimentoChange: (de: Date | null, ate: Date | null) => void,
  onClearFilters: () => void,
};

export const Header = ({
  selectedIdCargo,
  cargos,
  selectedIdFuncionario,
  funcionarios,
  selectedIdCentroCustos,
  centroCustos,
  vencimentoDe,
  vencimentoAte,
  onSelectedCargoChange,
  onSelectedFuncionarioChange,
  onSelectedCentroCustoChange,
  onVencimentoChange,
  onClearFilters,
}: Props) => {
  return (
    <>
      <CascateList
        title="Filtros"
        defaultOpen>
        <div className="w-full flex flex-col gap-6 items-center justify-center">
          <div className="w-full grid gap-6 grid-cols-1 md:grid-cols-2 2xl:grid-cols-3 grid-flow-row-dense ">
            <DefaultAutocomplete
              label='Cargo'
              value={cargos.find(x => x.idCargo === selectedIdCargo) ?? null}
              options={cargos}
              getOptionLabel={x => x.descricao}
              getOptionKey={x => x.idCargo}
              onChange={x => onSelectedCargoChange(x?.idCargo ?? null)} />

            <DefaultAutocomplete
              label='Funcionário'
              value={funcionarios.find(x => x.idFuncionario === selectedIdFuncionario) ?? null}
              options={funcionarios}
              getOptionLabel={x => x.nome}
              getOptionKey={x => x.idFuncionario}
              onChange={x => onSelectedFuncionarioChange(x?.idFuncionario ?? null)} />

            <DefaultMultiAutocomplete
              label='Centro de Custo'
              value={centroCustos.filter(x => selectedIdCentroCustos?.includes(x.id))}
              options={centroCustos}
              getOptionLabel={x => x.title}
              getOptionKey={x => x.id}
              onChange={x => onSelectedCentroCustoChange(x?.map(y => y.id) ?? null)} />

            <DefaultDateRangePickerInput
              label='Vencimento'
              dataDe={vencimentoDe}
              dataAte={vencimentoAte}
              onChange={onVencimentoChange}
            />

          </div>
          <div className="w-full flex justify-end">
            <div className="w-[180px]">
              <PrimaryButton
                startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
                buttonColor="yellow"
                onClick={onClearFilters}>
                Limpar filtros
              </PrimaryButton>
            </div>
          </div>
        </div>
      </CascateList>
    </>
  );
}